export function openCart(getComponentExists, openOverlay) {
  if (typeof getComponentExists !== 'function' || typeof openOverlay !== 'function') {
    return
  }
  if (getComponentExists('cart-drawer')) {
    openOverlay({
      component: 'cart-drawer',
      ignoreDismissed: true,
      namespace: 'cartDrawer',
    })
  } else if (getComponentExists('cart-notice')) {
    openOverlay({
      namespace: 'cartNotice',
      ignoreDismissed: true,
    })
  }
}

// Normalize metafield booleans from Shopify responses.
function normalizeMetafieldBoolean(value) {
  return value === true || value === 'true' || value === 'True'
}

// Strip the backorder prefix before showing the message.
function cleanBackorderMessage(value = '') {
  return String(value || '').replace(/^backordered:\s*/i, '').trim()
}

// Compare two property objects by key and value.
function haveSameProperties(current = {}, next = {}) {
  const currentKeys = Object.keys(current)
  const nextKeys = Object.keys(next)

  if (currentKeys.length !== nextKeys.length) {
    return false
  }

  return currentKeys.every((key) => current[key] === next[key])
}

// Build the managed cart property update payload.
export function buildManagedPropertyUpdate(
  item,
  extraItem = {},
  { backorderKey = 'Backordered', engravingEddKey = 'Estimated Ship Date' } = {},
) {
  const currentProperties = { ...(item.properties || {}) }
  const nextProperties = { ...currentProperties }

  const isBackordered = normalizeMetafieldBoolean(extraItem.is_backordered)

  if (isBackordered) {
    nextProperties._backorder = 'true'
    delete nextProperties._edd

    const nextBackorderMessage = cleanBackorderMessage(extraItem.backorder_message)
    if (nextBackorderMessage) {
      nextProperties[backorderKey] = nextBackorderMessage
    } else {
      delete nextProperties[backorderKey]
    }
  } else {
    delete nextProperties._backorder
    delete nextProperties[backorderKey]
  }

  if (
    Object.prototype.hasOwnProperty.call(currentProperties, engravingEddKey) &&
    extraItem.engraving_edd
  ) {
    nextProperties[engravingEddKey] = extraItem.engraving_edd
  }

  const finalProperties = Object.keys(nextProperties).length
    ? nextProperties
    : { _edd: '' }

  if (haveSameProperties(currentProperties, finalProperties)) {
    return null
  }

  return {
    id: item.key,
    quantity: item.quantity,
    properties: finalProperties,
  }
}
